export default {
    getFormFields:{
        data:[],
        error:null,
        loading:false,
    },
    saveAssessmentForm:{
        data:[],
        error:null,
        loading:false,
    },
    AssessmentFormReports:{
        data:[],
        error:null,
        loading:false,
    },
    ItemPreAutho:{
        data:[],
        error:null,
        loading:false,
    },
    getMedicRoutes:{
        data:[],
        error:null,
        loading:false,
    },
    requestMedic:{
        data:[],
        error:null,
        loading:false,
    },getIpdWards:{
        data:[],
        error:null,
        loading:false,
    },getAdmittedPatient:{
        data:[],
        error:null,
        loading:false,
    },mostFrequentlyServices:{
        data:[],
        error:null,
        loading:false,
    },doctorTimeSlotsStates:{
        data:[],
        error:null,
        loading:false,
    },patientPackageStates:{
        data:[],
        error:null,
        loading:false,
    }
}